import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Smartphone, X } from 'lucide-react';

// Teaser app iOS/Android. Si chiude per sempre (localStorage): è una notizia,
// non un avviso di servizio, quindi non deve tornare a ogni visita.
// Per spegnerlo per tutti: APP_TEASER_ACTIVE = false.
export const APP_TEASER_ACTIVE = true;
const DISMISS_KEY = 'scanmarket_app_teaser_dismissed_v1';

export function AppTeaserBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!APP_TEASER_ACTIVE) return;
    try {
      if (localStorage.getItem(DISMISS_KEY) === '1') return;
    } catch (e) { /* storage non disponibile: mostra comunque */ }
    setVisible(true);
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch (e) { /* noop */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="app-teaser-banner"
      role="status"
      className="border-b border-border/60 bg-muted/40"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-2 flex items-center gap-3">
        <span className="flex-shrink-0 inline-flex items-center justify-center w-7 h-7 rounded-lg bg-foreground/5 text-foreground">
          <Smartphone size={14} />
        </span>
        <p className="flex-1 min-w-0 text-xs sm:text-sm leading-snug">
          <span className="font-semibold">{t('appTeaserTitle')}</span>
          <span className="text-muted-foreground"> — {t('appTeaserBody')}</span>
        </p>
        <button
          type="button"
          onClick={dismiss}
          data-testid="app-teaser-dismiss"
          aria-label={t('announcementDismiss')}
          className="flex-shrink-0 p-1.5 rounded-lg text-muted-foreground hover:text-foreground hover:bg-foreground/5 transition-colors"
        >
          <X size={15} />
        </button>
      </div>
    </div>
  );
}

export default AppTeaserBanner;
